import React, { useState, useCallback } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import BrandedModeForm from './components/BrandedModeForm';
import FreshModeForm from './components/FreshModeForm';
import HistoryGallery from './components/HistoryGallery';
import { useCreativeJobPoll } from './hooks/useCreativeJobPoll';

function CreativeGeneratorPage() {
  const [activeTab, setActiveTab] = useState('branded');
  const [activeJobId, setActiveJobId] = useState(null);

  // A new job started in either form — start watching it at the page level so
  // the completion toast survives tab switches.
  const handleJobStart = useCallback((jobId) => {
    setActiveJobId(jobId);
  }, []);

  const clearActiveJob = useCallback(() => {
    setActiveJobId(null);
  }, []);

  useCreativeJobPoll(activeJobId, {
    onComplete: clearActiveJob,
    onFailed: clearActiveJob,
    onViewHistory: () => setActiveTab('history'),
  });

  return (
    <div className="p-4 md:p-8">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-white mb-2">Creative Generator</h1>
        <p className="text-white/60">Generate stunning visuals powered by AI</p>
      </div>

      {/* Tabs */}
      <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
        <TabsList className="grid w-full max-w-md grid-cols-3 bg-white/5 border border-white/10">
          <TabsTrigger value="branded">Branded Creative</TabsTrigger>
          <TabsTrigger value="fresh">Fresh Creative</TabsTrigger>
          <TabsTrigger value="history">History</TabsTrigger>
        </TabsList>

        <div className="mt-6">
          <TabsContent value="branded" className="m-0">
            <BrandedModeForm onJobStart={handleJobStart} />
          </TabsContent>
          <TabsContent value="fresh" className="m-0">
            <FreshModeForm onJobStart={handleJobStart} />
          </TabsContent>
          <TabsContent value="history" className="m-0">
            <HistoryGallery />
          </TabsContent>
        </div>
      </Tabs>
    </div>
  );
}

export default CreativeGeneratorPage;
